import { useLocation } from "react-router-dom";

import { Container } from "@mui/material";
import { PATH_AUTH } from "src/routes/paths";

export default function AuthPageLayout({ children }) {
  const { pathname } = useLocation();
  if (!pathname.includes(PATH_AUTH.createAccount)) {
    return (
      <Container
        maxWidth="xxl"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "100vh",
          backgroundSize: "cover",
          backgroundImage: "url(/static/images/auth/auth-background.png)",
        }}
      >
        {children}
      </Container>
    );
  }
  return children;
}
